import { type ObjectValuesUnionType } from '../../../utils/typing';

export const MPBannerStatuses = Object.freeze({
  NOT_CONNECTED: 'NOT_CONNECTED', // not connected
  NOT_OPT_IN_YET: 'NOT_OPT_IN_YET', // connecté mais n'a pas encore participé
  FREEBETS_AVAILABLE: 'FREEBETS_AVAILABLE',
  PLAYING: 'PLAYING', // bannière par defaut si l'utilisateur participe déjà avec son avancement
});

export type MPBannerStatus = ObjectValuesUnionType<typeof MPBannerStatuses>;
